import React, { useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";

import Map from "./components/Map";
import ControlPanel from "./components/ControlPanel";
import MapContextProvider from "./contexts/MapContextProvider";
import NotificationBanner from "./components/NotificationBanner";

import "./App.css";

function App() {
  const [showBanner, setShowBanner] = useState<null | string>(null);

  // console.log("App");

  return (
    <div className="App">
      <Router>
        <MapContextProvider>
          <Map setShowBanner={setShowBanner} />
          <ControlPanel setShowBanner={setShowBanner} />
        </MapContextProvider>
        {showBanner && (
          <NotificationBanner
            errorMessage={showBanner}
            setShowBanner={setShowBanner}
            showBanner={showBanner}
          />
        )}
      </Router>
    </div>
  );
}

export default App;
